import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConditionalClassModule } from '@core-mkt/services/conditional-class/conditional-class.module';
import { DurationModule } from '@core-mkt/services/duration/duration.module';
import { QueryParamModule } from '@core-mkt/services/query-param/query-param.module';
import { VisionButtonModule } from '@core-mkt/shared/components/vision-button/vision-button.module';
import { VisionVideoButtonModule } from '@core-mkt/shared/components/vision-video-button/vision-video-button.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CategoryWidgetModule } from '../category-widget/category-widget.module';
import { WebinarScheduleModule } from '../webinar-schedule/webinar-schedule.module';
import { TopSectionButtonGroupComponent } from './top-section/button-group/top-section-button-group.component';
import { TopSectionCoursePopupBannerComponent } from './top-section/course-popup-banner/top-section-course-popup-banner.component';
import { FeaturedContentComponent } from './top-section/featured-content/featured-content.component';
import { TopSectionComponent } from './top-section/top-section.component';
import { TopSectionTrustpilotComponent } from './top-section/trustpilot/top-section-trustpilot.component';
import { TopSectionWysiwygComponent } from './top-section/wysiwyg/top-section-wysiwyg.component';

@NgModule({
  exports: [TopSectionComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    DurationModule,
    QueryParamModule,
    ConditionalClassModule,
    VisionButtonModule,
    VisionVideoButtonModule,
    CategoryWidgetModule,
    WebinarScheduleModule,
    TopSectionComponent,
    TopSectionWysiwygComponent,
    FeaturedContentComponent,
    TopSectionCoursePopupBannerComponent,
    TopSectionTrustpilotComponent,
    TopSectionButtonGroupComponent,
  ],
})
export class TopSectionModule {}
